export const proxyArray = ({ afterChangeHandler }) => {
  const executeOriginalActionWithHandlers = (target, prop, handlers = []) => (...args) => {
    const originalActionResults = Array.prototype[prop].apply(target, args);
    handlers.forEach((handler) => handler?.(target));
    return originalActionResults;
  };

  const arrayChangeHandler = {
    get(target, prop) {
      const val = target[prop];
      if (typeof val === 'function') {
        if (['push', 'pop', 'shift', 'unshift', 'splice', 'reverse'].includes(prop)) {
          return executeOriginalActionWithHandlers(target, prop, [afterChangeHandler]);
        }
        return val.bind(target);
      }
      return val;
    },
    set(target, property, value) {
      target[property] = value;
      afterChangeHandler?.(target);
      return true;
    },
  };

  return new Proxy([], arrayChangeHandler);
};
